module.exports = __webpack_public_path__ + "static/media/empty-state-mobile-icon.9c0d633e.svg";